/** @format */

export function GbDragHandleDirective($document, $rootScope) {
    'ngInject';

    return {
        restrict: 'A',
        require: {
            gbDraggable: '^^',
        },
        link: function (scope, element, attrs, controllers) {
            scope.gbDraggable = controllers.gbDraggable;
        },
        controller: class GbDraggableDirective {
            constructor($element, $document, $rootScope, $scope) {
                'ngInject';

                this.$element = $element;
                this.$document = $document;
                this.$rootScope = $rootScope;
                this.$scope = $scope;

                this.dragging = false;
            }

            mouseHandler() {
                this.$document.on('mousemove', (ev) => {
                    if (this.dragging) {
                        let xPos = this.getNewXPos(ev);
                        let yPos = this.getNewYPos(ev);

                        this.$scope.gbDraggable.getElement().css('left', `${xPos}px`);
                        this.$scope.gbDraggable.getElement().css('top', `${yPos}px`);
                    }
                });
            }

            getNewXPos(ev) {
                let val = ev.x - this.mouseOffsetX;

                val = this.stopOverflowX(val);

                return val;
            }

            getNewYPos(ev) {
                let val = ev.y - this.mouseOffsetY;

                val = this.stopOverflowY(val);

                return val;
            }

            stopOverflowX(val) {
                let maxX = this.getMaxXPos();

                // Don't allow to overflow off screen
                if (val < 0) {
                    val = 0;
                } else if (val > maxX) {
                    val = maxX;
                }

                return val;
            }

            stopOverflowY(val) {
                let maxY = this.getMaxYPos();

                // Don't allow to overflow off screen
                if (val < 0) {
                    val = 0;
                } else if (val > maxY) {
                    val = maxY;
                }

                return val;
            }

            getBody() {
                return this.$document[0].body;
            }

            getMaxXPos() {
                return this.getBody().offsetWidth - this.$scope.gbDraggable.getElement()[0].offsetWidth;
            }

            getMaxYPos() {
                return this.getBody().offsetHeight - this.$scope.gbDraggable.getElement()[0].offsetHeight;
            }

            getCurrentXPos() {
                return this.$scope.gbDraggable.getElement()[0].offsetLeft;
            }

            getCurrentYPos() {
                return this.$scope.gbDraggable.getElement()[0].offsetTop;
            }

            startDragStartWatcher() {
                this.$element.on('mousedown', (ev) => {
                    let ele = this.$scope.gbDraggable.getElement()[0];
                    let parentX = ele.offsetLeft;
                    let parentY = ele.offsetTop;

                    this.mouseOffsetX = ev.x - parentX;
                    this.mouseOffsetY = ev.y - parentY;

                    this.dragging = true;
                    this.mouseHandler();

                    if (typeof this.$scope.gbDraggable.gbOnDrag === 'function') {
                        let $event = {
                            x: this.getCurrentXPos(),
                            y: this.getCurrentYPos(),
                            xPercent: (this.getCurrentXPos() / this.getBody().offsetWidth) * 100,
                            yPercent: (this.getCurrentYPos() / this.getBody().offsetHeight) * 100,
                        };

                        this.$scope.gbDraggable.gbOnDrag({
                            $event,
                        });
                    }
                });
            }

            startDragStopWatcher() {
                let callback = (ev) => {
                    this.$document.off('mousemove');

                    if (this.dragging && typeof this.$scope.gbDraggable.gbOnDrop === 'function') {
                        let $event = {
                            x: this.getCurrentXPos(),
                            y: this.getCurrentYPos(),
                            xPercent: (this.getCurrentXPos() / this.getBody().offsetWidth) * 100,
                            yPercent: (this.getCurrentYPos() / this.getBody().offsetHeight) * 100,
                        };

                        this.$scope.gbDraggable.gbOnDrop({
                            $event,
                        });
                    }

                    this.dragging = false;
                };

                this.$document.on('mouseup', callback);
            }

            $onInit() {
                this.startDragStartWatcher();
                this.startDragStopWatcher();

                this.$rootScope.$watch(() => {
                    if (this.getCurrentXPos() > this.getMaxXPos()) {
                        this.$scope.gbDraggable
                            .getElement()
                            .css('left', `${this.stopOverflowX(this.getCurrentXPos())}px`);
                    }

                    if (this.getCurrentYPos() > this.getMaxYPos()) {
                        this.$scope.gbDraggable
                            .getElement()
                            .css('top', `${this.stopOverflowY(this.getCurrentYPos())}px`);
                    }
                });
            }
        },
    };
}
